import * as go from 'gojs'

function expandedWalk (g, depth) {
  if (g instanceof go.Group && g.isSubGraphExpanded) {
    let maxSoFar = depth
    g.memberParts.each(function (m) {
      maxSoFar = Math.max(expandedWalk(m, depth + 1), maxSoFar)
    })
    return maxSoFar
  } else {
    return depth
  }
}

function calculateExpandedDepth (diagram) {
  let maxSoFar = 0
  diagram.findTopLevelGroups().each(function (g) {
    maxSoFar = Math.max(expandedWalk(g, 0), maxSoFar)
  })
  return maxSoFar
}

function groupDepthWalk (g, depth) {
  let maxSoFar = depth
  if (g instanceof go.Group) {
    g.memberParts.each(function (m) {
      maxSoFar = Math.max(groupDepthWalk(m, depth + 1), maxSoFar)
    })
  }
  return maxSoFar
}

function calculateDepth (diagram) {
  let maxSoFar = 0
  diagram.findTopLevelGroups().each(function (g) {
    maxSoFar = Math.max(groupDepthWalk(g, 0), maxSoFar)
  })
  return maxSoFar
}

export { calculateExpandedDepth, calculateDepth }



// WEBPACK FOOTER //
// ./src/graph_parts/depth.js